import { render } from "./CreateCompetitionModal.vue?vue&type=template&id=20c9420a&ts=true"
import script from "./CreateCompetitionModal.vue?vue&type=script&lang=ts"
export * from "./CreateCompetitionModal.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/nicolacentonze/Desktop/Projects/cons-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__